/**
 * Fire event `bb-p:control-filter' to hook up changes other plugins
 * would like to perform on a control.
 *
 * The arguments given to the eventhandler are:
 *
 * this event,
 * the control,
 * the group object (node),
 * the index within the group (or index of column within a grid),
 * the grid (if applicable)
 * the original data object
 *
 * It fires both on normal controls and on column definitions within
 * grids; whenever it is a column definition is within a grid the 4th
 * argument to the event is the grid control itself.
 *
 */

(function ($, win, doc) {
  $(function () {
    $(doc).on("bb:preHandleData", function (event, data) {
      if (data && data.groups) {
        $.each(data.groups, function (_, group) {
          $.each(group.controls, function (_, control) {
            $(doc).trigger("bb-p:control-filter", [
              control,
              group,
              _,
              undefined,
              data
            ]);
            if (control.controltype === "grid")
              $.each(control.columns, function (_, column) {
                $(doc).trigger("bb-p:control-filter", [
                  column,
                  group,
                  _,
                  control,
                  data
                ]);
              });
          });
        });
      }
    });
  });
})(jQuery, window, document);
